import styled from 'styled-components';
import { Header as HeaderLayoutComponent, Loader as LoaderLayoutComponent } from '@playbookux/playbook-web-core';

export const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 10px;
`;

export const ContainerItems = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
`;

export const Message = styled(HeaderLayoutComponent)`
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
`;

export const Loader = styled(LoaderLayoutComponent).attrs(() => ({
  inline: false,
}))``;
